var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ViewEmailSetting',{attrs:{"configKey":_vm.$route.params.emailTemplate,"showOtherTemplatesButton":_vm.showOtherTemplatesButton}})}
var staticRenderFns = []

export { render, staticRenderFns }